import { useNavigate } from "react-router-dom"
import { FaChevronLeft } from 'react-icons/fa'
import { ToastContainer } from "react-toastify"
import SensorSosSettingsComp from "../../../components/SensorSOSSettings/SensorSOSSettingsComp"

const Icon: any = FaChevronLeft

const AddSensorSosSettings = () => {
    const navigate = useNavigate()
    const getBack = () => {
        navigate(-1)
    }

    return (
        <section className='dashboard-section'>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        {/* <div className='d-flex gap-1 mb-2'>
                            <div className='dashboard-table-title-section title-line w-100'>
                                <h2>Add Sensor SOS Settings</h2>
                            </div>
                        </div> */}
                        <div className='d-flex gap-1 mb-2'>
                            <button onClick={getBack} className='d-flex align-items-center'>
                                <Icon size={20} />
                            </button>
                            <div className='dashboard-table-title-section w-100'>
                                <h2>Add Sensor SOS Settings</h2>
                            </div>
                        </div>
                    </div>
                    <SensorSosSettingsComp/>
                </div>
            </div>

        </section>
    )
}

export default AddSensorSosSettings
